import { ResourceHeaders } from '..'
import {
  BusinessHeader,
  CreateLinkedRecordHeader,
  DateHeader,
  IdHeader,
  NegotiationStatusHeader,
  PersonHeader,
  PriceHeader,
  VehicleHeader,
} from '../../headers'
import { Person } from '@/entities/persons'
import { Helpers } from '@/views/datatables/resources/helpers'
import { Lead } from '@/entities/crm'
import { Process } from '@/entities/settings'
import { CellType } from '@/components/dataTables/cell'

export const headers: ResourceHeaders = [
  {
    ...IdHeader,
    text: 'Nº',
    value: '@',
    options: {
      expandOff: true,
      action: {
        edit: Helpers.linkedModel,
      },
    },
    width: 80,
  },
  { ...VehicleHeader, text: 'Vehículo', value: 'auto' },
  { ...DateHeader, text: 'Creación', value: 'created' },
  { ...BusinessHeader, text: 'Negocio', value: 'pipeline' },
  {
    ...PersonHeader,
    text: 'Cliente',
    value: '@',
    options: {
      path: 'client.name',
      trigger: Helpers.linkedModel,
      action: {
        always: true,
        color: 'green',
        icon: 'mdi-whatsapp',
        messaging: true,
        trigger: (item: Lead, process: Process, system: string) => Helpers.contact(item, 'client', process, system),
      },
      disabledMissingProperty: ['phone'],
    },
  },
  { ...PriceHeader, text: 'Precio tasación', value: 'appraisalPrice' },
  { ...PriceHeader, text: 'Costo inspección', value: 'inspectionAmount', width: 160 },
  { ...PriceHeader, text: 'Precio autorizado', value: 'negotiationResponse' },
  { ...NegotiationStatusHeader, text: 'Estado negociación', value: '@' },
  {
    align: 'center',
    width: 150,
    filterable: true,
    type: CellType.linked,
    text: 'Supervisor',
    value: 'inspection.supervisor',
    options: {
      action: {
        color: 'primary',
        always: true,
        icon: 'mdi-whatsapp',
        only: true,
        trigger: (item: Person) => Helpers.contact(item, 'Supervisor'),
      },
      disabledMissingProperty: ['phone'],
    },
  },
  {
    ...CreateLinkedRecordHeader,
    text: 'Comprar',
    value: 'buttonPurchase',
    options: {
      tooltip: 'Comprar',
      action: {
        color: 'green',
        icon: 'mdi-cart-arrow-down',
        only: true,
        trigger: item => Helpers.linkedModel(item),
      },
    },
  },
]

export default function (): ResourceHeaders {
  return headers
}
